import * as React from "react";
const SvgBugDebug20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm3.57 1.55a3 3 0 1 0-5.14 0c-1.07.48-2 1.251-2.727 2.217l-2.48-1.654-1.11 1.664 2.592 1.728A8.884 8.884 0 0 0 3.055 11H.5v2h2.555c.008.074.017.148.027.221l1.934-1.706C5.196 8.738 6.922 6.641 9 6.124V8l2-1.765v-.111l.097.025 1.695-1.495a6.429 6.429 0 0 0-.223-.105ZM4.602 17.095 2.16 19.25l-.75.662-1.323-1.5.75-.662 17-15 .75-.661 1.323 1.5-.75.66-3.483 3.074A8.734 8.734 0 0 1 16.945 11H19.5v2h-2.555a8.917 8.917 0 0 1-.494 2.1l2.436 1.623-1.11 1.664-2.24-1.493C14.28 18.76 12.308 20 10 20c-2.224 0-4.136-1.15-5.397-2.904Zm9.555-8.431L11 11.45v6.425c2.197-.547 4-2.86 4-5.876 0-1.26-.315-2.398-.842-3.335ZM9 13.216v4.66c-1.133-.282-2.161-1.034-2.891-2.109l2.89-2.551Z",
      clipRule: "evenodd"
    })
  );
export default SvgBugDebug20Px;
